import httpClient from '../httpClient';

const post = async (data) => {
  return await httpClient.post(
    `${process.env.REACT_APP_API_HOST}/term_resumes/`,
    data,
  );
};

const remove = async (id) => {
  return await httpClient.delete(
    `${process.env.REACT_APP_API_HOST}/term_resumes/${id}`,
  );
};

const ajaxTable = async (
  query = '',
  page = 1,
  pageSize = 10,
  _sortBy = 'id',
  search = false,
  exportCSV = false,
) => {
  let searchBy = '';

  if (search) searchBy = '&filter[search]=' + search;

  if (exportCSV)
    return await httpClient.get(
      `/term_resumes/export/?filter[termino]=${query}${searchBy}`,
      {
        responseType: 'blob',
      },
    );
  else
    return await httpClient.get(
      `/term_resumes/?filter[termino]=${query}&page[number]=${page}&page[size]=${pageSize}${searchBy}`,
    );
};

const getListByJobTerm = async (term_id) => {
  return await httpClient.get(
    `/term_resumes/job_list/?filter[termino]=${term_id}`,
  );
};

export { post, ajaxTable, remove, getListByJobTerm };
